<div (drop)="onFileDrop($event)">

  <div *ngIf="!isJapanOrder" class="header-text">{{'talent-happy-path.talent-profile.file-upload.resume' | translate}}</div>

  <div *ngIf="isJapanOrder && !isOptional" class="header-text">{{'talent-happy-path.talent-profile.file-upload.rirekisho-resume' | translate}}</div>
  <div *ngIf="isJapanOrder && isOptional" class="header-text">
    <span>{{'talent-happy-path.talent-profile.file-upload.keirekisho-resume' | translate}}</span>
    <span class="optional-text">{{"talent-happy-path.quick-apply.submit-page.optional" | translate}}</span>
  </div>

  <div class="success-container" [hidden]="!(uploadSuccess || showLatestResume)">
    <div class="resume-sub-header" *ngIf="resumeDetail">
      <span>  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 6V16.5C15.5 18.71 13.71 20.5 11.5 20.5C9.29 20.5 7.5 18.71 7.5 16.5V6C7.5 4.62 8.62 3.5 10 3.5C11.38 3.5 12.5 4.62 12.5 6V15.5C12.5 16.05 12.05 16.5 11.5 16.5C10.95 16.5 10.5 16.05 10.5 15.5V6H9V15.5C9 16.88 10.12 18 11.5 18C12.88 18 14 16.88 14 15.5V6C14 3.79 12.21 2 10 2C7.79 2 6 3.79 6 6V16.5C6 19.54 8.46 22 11.5 22C14.54 22 17 19.54 17 16.5V6H15.5Z"
        fill="black" />
      </svg>
      </span>
      <div>
        <span class="main-text" *ngIf="!isOptional">{{resumeDetail.fileName}}</span>
        <span class="main-text" *ngIf="isOptional">{{resumeDetail.optionalFileName}}</span>
        <div class="sub-text">last updated {{$safeNavigationMigration(resumeDetail?.lastUpdatedDate) | date: 'MMM d, y'}} </div>
      </div>
    </div>
  </div>

  <div [hidden]="validFileTypeSelected" class="error-container">
    <div class="resume-error">
      <span  id="error-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 17V15H13V17H11ZM11 7V13H13V7H11Z"
            fill="#E70608" />
        </svg>
      </span>
      <div class="error-text">
        <span class="resume-error-title">{{fileName}}</span>
        <div class="resume-error-text">{{"talent-happy-path.quick-apply.submit-page.resume.invalid-file-type" | translate}}</div>
      </div>
    </div>
  </div>

  <div class="upload-container" appDragDrop (fileDropped)="onFileDrop($event)">
    <p [hidden]="uploading">
      <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M30.5 25.0003V30.0003H10.5V25.0003H7.16663V30.0003C7.16663 31.8337 8.66663 33.3337 10.5 33.3337H30.5C32.3333 33.3337 33.8333 31.8337 33.8333 30.0003V25.0003H30.5ZM12.1666 15.0003L14.5166 17.3503L18.8333 13.0503V26.667H22.1666V13.0503L26.4833 17.3503L28.8333 15.0003L20.5 6.66699L12.1666 15.0003Z"
          fill="#FF6720" />
      </svg>
    </p>
    <div [hidden]="uploading">
      <div class="text-primary">{{"talent-happy-path.quick-apply.submit-page.resume.upload-text" | translate}}</div>
      <div class="small-text">{{"talent-happy-path.quick-apply.submit-page.resume.file-types" | translate}}</div>
    </div>

    <input type="file" class="file-input" multiple="false" id="resume-file"
      accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png, text/plain, application/pdf, doc, docx, text/rtf, application/rtf, .html"
      (change)="onFileSelected($event)" #fileUpload>
    <button class="browse-button" id="upload-button"
            mat-stroked-button
            (click)="fileUpload.click()"
            [hidden]="fileSelected || uploading">
            <span class="label-large">{{ (uploadSuccess ? "talent-happy-path.quick-apply.submit-page.resume.button-update" : "talent-happy-path.quick-apply.submit-page.resume.button-browse" ) | translate }}</span>
    </button>

    <div class="spinner-container" [hidden]="!fileSelected && !uploading">
      <mat-spinner [diameter]="40" *ngIf="uploading"></mat-spinner>
    </div>


  @if (fileUploadUserType === FileUploadUserType.GATHER && talentId) {
    <div class="existing-resume-container gather-existing-resume-container">
      <svg class="info-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_59557_8906)">
          <path d="M28.85 16.1898C28.85 23.2867 23.0969 29.0398 16 29.0398C8.90317 29.0398 3.15002 23.2867 3.15002 16.1898C3.15002 9.09298 8.90317 3.33984 16 3.33984C23.0969 3.33984 28.85 9.09298 28.85 16.1898Z" fill="#254C8C" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M16.1029 11.6189C15.7036 11.6189 15.4241 11.539 15.2644 11.3793C15.1046 11.2082 15.0248 10.9971 15.0248 10.7461V10.4723C15.0248 10.2214 15.1046 10.016 15.2644 9.85629C15.4241 9.68517 15.7036 9.59961 16.1029 9.59961C16.5021 9.59961 16.7816 9.68517 16.9414 9.85629C17.1011 10.016 17.1809 10.2214 17.1809 10.4723V10.7461C17.1809 10.9971 17.1011 11.2082 16.9414 11.3793C16.7816 11.539 16.5021 11.6189 16.1029 11.6189ZM12.2355 21.236H15.4184V14.7333H12.2355V13.5697H16.7873V21.236H19.7649V22.3996H12.2355V21.236Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_59557_8906">
            <rect width="32" height="32" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <div class="info-text">
        {{"gather.resume.upload-a-new-resume" | translate}}
      </div>
    </div>
  }

    <div class="name-text text-primary" *ngIf="fileName">{{fileName}}</div>
      @if (fileUploadUserType === FileUploadUserType.QUICK_APPLY && countryId != Countries.JP) {
        <div class="existing-resume-container" *ngIf="talentId">
          <svg class="info-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_59557_8906)">
              <path d="M28.85 16.1898C28.85 23.2867 23.0969 29.0398 16 29.0398C8.90317 29.0398 3.15002 23.2867 3.15002 16.1898C3.15002 9.09298 8.90317 3.33984 16 3.33984C23.0969 3.33984 28.85 9.09298 28.85 16.1898Z" fill="#254C8C" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M16.1029 11.6189C15.7036 11.6189 15.4241 11.539 15.2644 11.3793C15.1046 11.2082 15.0248 10.9971 15.0248 10.7461V10.4723C15.0248 10.2214 15.1046 10.016 15.2644 9.85629C15.4241 9.68517 15.7036 9.59961 16.1029 9.59961C16.5021 9.59961 16.7816 9.68517 16.9414 9.85629C17.1011 10.016 17.1809 10.2214 17.1809 10.4723V10.7461C17.1809 10.9971 17.1011 11.2082 16.9414 11.3793C16.7816 11.539 16.5021 11.6189 16.1029 11.6189ZM12.2355 21.236H15.4184V14.7333H12.2355V13.5697H16.7873V21.236H19.7649V22.3996H12.2355V21.236Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_59557_8906">
                <rect width="32" height="32" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <div class="info-text">{{"talent-happy-path.quick-apply.submit-page.resume.update-existing-info" | translate}}</div>
        </div>
      }
  </div>

</div>
